<template>
  <div id="dashboard">
    <div
      id="content"
      class="content"
    >
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-tachometer"></i>Tableau de Bord
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message
          v-if="!isAdmin[0]"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          Vous retrouvez ici en un coup d'oeil les informations clefs des Objectifs et Campagnes qui vous sont affectées.
          <br>
          Désactivez le mode <strong>"Direct"</strong> afin de sélectionner une période spécifique à étudier.
          <br>
          Réactivez le mode <strong>"Direct"</strong> afin de bénéficier d'un graphe à jour en direct.
          <br>
          Choisissez une date d'objectif dans <strong>"Tous les Objectifs"</strong>, et un <strong>Weezy</strong> pour en voir le résumé.
          <br>
          Faites de même dans <strong>"Toutes les Campagnes"</strong>, pour voir le résumé d'une campagne.
          <br>
          Le <strong>"son ambiant"</strong> affiché dans les graphes est la moyenne du volume sonore de la minute, mesurée en dB, et divisée par 10 pour un affichage plus visible des ventes.
        </b-message>
        <b-message
          v-if="isAdmin[0]"
          type="is-primary"
        >
          <i class="fal fa-info-circle"></i>
          Vous retrouvez ici en un coup d'oeil les informations clefs des Objectifs et Campagnes.
          <br>
          Désactivez le mode <strong>"Direct"</strong> afin de sélectionner une période spécifique à étudier.
          <br>
          Réactivez le mode <strong>"Direct"</strong> afin de bénéficier d'un graphe à jour en direct.
          <br>
          Choisissez une date d'objectif dans <strong>"Tous les objectifs"</strong>, pour en voir le résumé.
          <br>
          Faites de même dans <strong>"Toutes les Campagnes"</strong>, pour en voir le résumé d'une campagne.
          <br>
          Le <strong>"son ambiant"</strong> affiché dans les graphes est la moyenne du volume sonore de la minute, mesurée en dB, et divisée par 10 pour un affichage plus visible des ventes.
        </b-message>
      </div>
    </div>
    <div class="content">
      <ul>
        <dashboardGoalsComponent
          id="dashboardGoalsComponent"
          :weezys="weezys"
          :goals="goals"
          :campaigns="campaigns"
          :users="users"
          :volume_records="volume_records"
          :volume_compare_records="volume_compare_records"
          :isAdmin="isAdmin"
        />
      </ul>
      <ul>
        <dashboardCampaignsComponent
          id="dashboardGoalsComponent"
          ref="dashboardGoalsComponent"
          :weezys="weezys"
          :goals="goals"
          :campaigns="campaigns"
          :users="users"
          :sales="sales"
          :isAdmin="isAdmin"
          :ranking="ranking"
        />
      </ul>
    </div>
  </div>
</template>

<script>
import dashboardGoalsComponent from "@/components/dashboardGoalsComponent";
import dashboardCampaignsComponent from "@/components/dashboardCampaignsComponent";

import http from "@/modules/request";

export default {
  name: "dashboard",
  components: {
    dashboardGoalsComponent,
    dashboardCampaignsComponent
  },
  data() {
    return {
      goals: [],
      themes: [],
      campaigns: [],
      weezys: [],
      users: [],
      sales: [],
      ranking: [],
      volume_records: [],
      volume_compare_records: [],
      creation: undefined,
      recordsInterval: undefined,
      isAdmin: [undefined, undefined],
      campaignToRank: 0,
      weezyToGetRecordsFrom: null,
      goalToGetRecordsFrom: null,
      info_visible: false
    };
  },
  mounted() {
    this.getUsers();

    this.isAdmin = [
      this.$store.state.role == "admin",
      this.$store.state.weezy_id
    ];
    this.getGoals().then(goals => {
      if (!this.isAdmin[0]) {
        this.getSales();
      }

      this.getWeezys().then(weezys => {
        this.getCampaigns();
        // this.getRanking(this.campaignToRank);
        if (weezys.length == 1 && !this.isAdmin[0]) {
          this.weezyToGetRecordsFrom = this.weezys[0].id;
        }
        // this.getVolumeRecords(
        //   this.weezyToGetRecordsFrom,
        //   this.goalToGetRecordsFrom
        // );
      });
    });
    this.refreshData();
  },
  beforeDestroy() {
    clearInterval(this.creation);
    clearInterval(this.recordsInterval);
  },
  methods: {
    refreshData() {
      this.creation = setInterval(() => {
        if (!this.isAdmin[0]) {
          this.getSales();
        }
        this.getWeezys().then(weezys => {
          this.getGoals();
          this.getUsers();
          this.getCampaigns();
          this.getRanking(this.campaignToRank);
        });
      }, 90000);

      this.recordsInterval = setInterval(() => {
        if (
          this.weezyToGetRecordsFrom != null &&
          this.goalToGetRecordsFrom != null
        ) {
          this.getVolumeRecords(
            this.weezyToGetRecordsFrom,
            this.goalToGetRecordsFrom
          );
        }
      }, 90000);
    },
    getGoals() {
      return new Promise((resolve, reject) => {
        http
          .get("/goalswithsales")
          .then(response => {
            var tempGoals = response.data;
            var visibleGoals = [];
            for (var i = 0; i < tempGoals.length; i++) {
              if (!tempGoals[i].is_hidden) {
                visibleGoals.push(tempGoals[i]);
              }
            }
            for (var i = 0; i < visibleGoals.length; i++) {
              //Convert Data to date
              if (visibleGoals[i].activation_date_time != null) {
                visibleGoals[i].activation_date_time = new Date(
                  visibleGoals[i].activation_date_time
                );
              }
            }
            this.goals = visibleGoals;
            resolve(visibleGoals);
          })
          .catch(error => {
            reject(error);
            console.log(error);
            this.errored = true;
          });
      });
    },
    getUsers() {
      http
        .get("/privateusers")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getSales() {
      http
        .get("/salesnogoal")
        .then(response => {
          this.sales = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getRanking(campaign_id) {
      if (campaign_id > 0) {
        http
          .get("/campaigns/" + campaign_id + "/ranking")
          .then(response => {
            this.ranking = response.data.sort((a, b) => b.sales - a.sales);
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
          });
      }
    },
    getWeezys() {
      return new Promise((resolve, reject) => {
        http
          .get("/weezys")
          .then(response => {
            resolve(response.data);
            this.weezys = response.data;
          })
          .catch(error => {
            reject(error);
            console.log(error);
            this.errored = true;
          });
      });
    },
    getCampaigns() {
      return new Promise((resolve, reject) => {
        http
          .get("/campaigns")
          .then(response => {
            this.campaigns = response.data;
            resolve();
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
            reject();
          });
      });
    },
    getVolumeRecords(fromWeezyWithId, fromGoalId) {
      http
        .get(
          "/weezys/" +
            fromWeezyWithId +
            "/goals/" +
            fromGoalId +
            "/volume-records"
        )
        .then(response => {
          this.volume_records = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getCompareVolumeRecords(fromWeezyWithId, fromGoalId) {
      http
        .get(
          "/weezys/" +
            fromWeezyWithId +
            "/goals/" +
            fromGoalId +
            "/volume-records"
        )
        .then(response => {
          this.volume_compare_records = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}

.add-config {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>